module.exports = __webpack_public_path__ + "img/3.a080b9d0.png";